import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'

import { Pagination } from 'components'
import ManualAnalysisSearchBar from 'components/ManualAnalysisSearchBar'
import { manualAnalisysAuditParams } from 'utils/constants/searchParams'
import ReviewTable from 'components/ReviewTable'
import { getAllReviews } from 'services/apiKYP'
import styles from './styles'
import ExportButton from "../../components/ExportButton"
import { REPORT_TYPE } from "../../utils/constants/reportType"

const ManualAnalysisAudit = () => {
    const classes = styles()
    const token = useSelector((state) => state.auth.access_token)

    const [loading, setLoading] = useState(true)
    const [reviews, setReviews] = useState(null)
    const [page, setPage] = useState(0)
    const [size, setSize] = useState(10)
    const [itemsCount, setItemsCount] = useState(1)
    const [searchParams, setSearchParams] = useState(manualAnalisysAuditParams)
    const [exportRequested, setExportRequested] = useState(false)

    const getData = () => {
        setLoading(true)

        const options = {
            params: {
                page: page + 1,
                size,
                ...searchParams,
            },
        }

        getAllReviews(token, options).then((response) => {
            const { data } = response
            setReviews(data?.items)
            setItemsCount(data?.total)
        }).catch(() => {
            setReviews([])
            setItemsCount(0)

        }).finally(() => {
            setLoading(false)
        })
    }

    const handleChangeSearchParams = (value) => {
        setSearchParams(value)
        setPage(0)
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setSize(event.target.value)
        setPage(0)
    }

    const reloadData = () => {
        getData()
    }

    useEffect(() => {
        setExportRequested(false)
    }, [searchParams])

    useEffect(() => {
        getData()
    }, [page, size, searchParams])

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <ManualAnalysisSearchBar setSearchParams={handleChangeSearchParams} />
                <ExportButton
                    reportType={REPORT_TYPE.REVIEW}
                    searchParams={searchParams}
                    disabled={exportRequested}
                    setExportRequested={setExportRequested}
                />
            </div>

            {loading ? (
                <div className={classes.loading}>
                    <CircularProgress size={64} color="primary" />
                    <span className={classes.loadingText}>
            Buscando análises...
          </span>
                </div>
            ) : (
                <React.Fragment>
                    <div className={classes.tableContainer}>
                        <ReviewTable reviews={reviews} reloadData={reloadData} />
                    </div>
                    {reviews?.length > 0 && (
                        <Pagination
                            count={itemsCount}
                            component="div"
                            page={page}
                            rowsPerPage={size}
                            rowsPerPageOptions={[10, 15, 20, 25, 30]}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

export default ManualAnalysisAudit
